import * as yup from 'yup';

function priceRangeTest(
  this: yup.TestContext,
  _value: string | undefined,
): boolean {
  const { priceMin, priceMax } = this.parent;

  if (!priceMin || !priceMax) {
    return true;
  }

  const min = Number(priceMin);
  const max = Number(priceMax);

  if (isNaN(min) || isNaN(max)) {
    return true;
  }

  return min <= max;
}

export const feeScheduleFilterBarSchema = yup.object({
  entities: yup
    .array()
    .of(
      yup.object({ id: yup.number().defined(), name: yup.string().defined() }),
    )
    .defined(),
  paymentTypes: yup.array().of(yup.string().defined()).defined(),
  paymentSystems: yup.array().of(yup.string().defined()).defined(),
  status: yup.string().defined(),
  priceMin: yup
    .string()
    .defined()
    .test('price-range', 'Min > Max', priceRangeTest),
  priceMax: yup
    .string()
    .defined()
    .test('price-range', 'Min > Max', priceRangeTest),
});
